export default "__VITE_ASSET__6d4cc615__"